const PropertyAvailability = {
  AVAILABLE: 'available',
  SOLD_OUT: 'sold-out',
  LIMITED: 'limited',
  DEFAULT: 'default'
};

export default PropertyAvailability;
